export default __webpack_public_path__ + "6ed59f962963a4a73af29e6b472608ab.svg";